
import { defineComponent, ref, computed } from 'vue'
import { Type, useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { useI18n } from 'vue-i18n'
import {
  ExaminationDataRes,
  ExaminationInfoService
} from '@/views/dashboard/group/client/terminal-info/examination-info/examination-info.service'
import ContentAdaptLayout from '@/views/dashboard/_components/content-adapt-layout/content-adapt-layout.vue'
import { formatTimeStamp } from '@/utils/time'
import dayjs from 'dayjs'
import ExaminationDetail from '@/views/dashboard/_components/examination/examination-detail.vue'
import { ExaminationDetailService } from '@/views/dashboard/_components/examination/examination-detail.service'
import { ExaminationService } from '@/views/dashboard/safe-status/examination-status/examination-status.service'

export default defineComponent({
  components: { ExaminationDetail, ContentAdaptLayout },
  props: {
    deviceId: {
      type: String,
      default: ''
    },
  },

  setup (props, context) {
    const { t, locale } = useI18n()
    const injector = useReflectiveInjector([ExaminationInfoService, {
      provide: ExaminationDetailService as Type<ExaminationDetailService>,
      useClass: ExaminationService
    }])
    const service = injector.get(ExaminationInfoService)

    const compData = ref({} as ExaminationDataRes)
    const isLoading = ref(false)
    const isDetailVisible = ref(false)

    const statusNameMap = computed(() => {
      void locale.value
      return {
        0: t('groupClient.terminalInfoDetail.examStatusDash'),
        1: t('groupClient.terminalInfoDetail.examStatusNotExamined'),
        2: t('groupClient.terminalInfoDetail.examStatusExamining'),
        3: t('groupClient.terminalInfoDetail.examStatusCompleted'),
        4: t('groupClient.terminalInfoDetail.examStatusTimeout'),
      } as Record<number, string>
    })

    function updateData () {
      isLoading.value = true
      service.getExaminationData({
        device_id: props.deviceId,
      }).then(response => {
        compData.value = response
      }).finally(() => {
        isLoading.value = false
      })
    }

    function isLong  (time: number) {
      return dayjs().subtract(7, 'day').valueOf() > (time * 1000)
    }

    updateData()

    return {
      statusNameMap,
      isLoading,
      isDetailVisible,
      compData,
      formatTimeStamp,
      isLong,
    }
  }
})
